import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Block } from '@guryou/html-components';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

const GenderRadio = ({ options, value, defaultValue = 'all' }) => {
  const { t } = useTranslation();
  const [ls, setLs] = useState(value || defaultValue);
  return (
    <Block margin={0} marginTop={6} textAlign="left">
      <FormControl component="fieldset" fullWidth>
        <FormLabel>{t('ONBOARD.whoFor')}</FormLabel>
        <RadioGroup row aria-label="position" defaultValue={ls} value={ls} onChange={e => setLs(e.target.value)}>
          {options.map(option => (
            <FormControlLabel value={option.value} key={option.label} control={<Radio color="primary" name="target" />} label={option.label} />
          ))}
        </RadioGroup>
      </FormControl>
    </Block>
  );
};

export default GenderRadio;
